import { render, staticRenderFns } from "./message.vue?vue&type=template&id=95390a02&scoped=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"
import style0 from "./message.vue?vue&type=style&index=0&id=95390a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95390a02",
  null
  
)

export default component.exports